export const ERROR_MESSAGES = {
  INVALID_BENEFICIARY_NAME_MESSAGE: 'invalid beneficiary name',
  INVALID_INTERMEDIARY_BANK_MESSAGE: 'invalid intermediary bank details',
}
